module.exports = __webpack_public_path__ + "static/media/rafael.e6d87014.md";